import type { ComponentProps } from 'react';
import dynamic from 'next/dynamic';
import React from 'react';
import { asGqlData, asWidgetProps } from 'Src/types/widget-helpers';
import { AsyncLoader } from 'Components/widgets/loading/async-loader/AsyncLoader';
import type { TrackingPayload } from 'Tracking/tracking-api/useTracking';
import 'Tracking/tracking-api/useTracking';
import { useGQL } from 'Utils/graphql-client/use-gql/useGQL';
import { CUSTOMER_BOOKING_RD_GET_RESORT_SETTINGS } from 'Utils/request/requestDictionary';
import { getResortDistrictQuery } from './resortDistrict.utils';
const ResortDistrict = dynamic(() => import('./ResortDistrict').then((mod) => mod.ResortDistrict), {
  ssr: false,
});
type Props = {
  access: string;
  resortId: string;
  title?: string;
  trackingData: TrackingPayload;
};
export const ResortDistrictContainer = (props: Props) => {
  const { resortId } = props;
  const { data, isLoading } = useGQL({
    query: getResortDistrictQuery(resortId),
    queryOptions: {
      requestName: CUSTOMER_BOOKING_RD_GET_RESORT_SETTINGS,
      cacheFront: {
        key: CUSTOMER_BOOKING_RD_GET_RESORT_SETTINGS + resortId,
      },
    },
    ignore: !resortId,
  });

  if (isLoading) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <AsyncLoader />
      </div>
    );
  }

  const gqlData = asGqlData<ComponentProps<typeof ResortDistrict>>(data);

  if (!gqlData?.resortAreas?.areas || !gqlData?.resortAreas?.geoData) {
    return null;
  }

  return (
    <ResortDistrict
      {...asWidgetProps<ComponentProps<typeof ResortDistrict>>({ ...gqlData, ...props })}
    />
  );
};
